var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Terms, colour=NeutralSubdued, htmlTag=img, assetKey=Content, state=Selected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "encrypted",
    d: "M11.3295 15H14.3295L13.7545 11.775C14.0879 11.6083 14.3504 11.3667 14.542 11.05C14.7337 10.7333 14.8295 10.3833 14.8295 10C14.8295 9.45 14.6337 8.97917 14.242 8.5875C13.8504 8.19583 13.3795 8 12.8295 8C12.2795 8 11.8087 8.19583 11.417 8.5875C11.0254 8.97917 10.8295 9.45 10.8295 10C10.8295 10.3833 10.9254 10.7333 11.117 11.05C11.3087 11.3667 11.5712 11.6083 11.9045 11.775L11.3295 15ZM12.8295 22C10.5129 21.4167 8.60036 20.0875 7.09203 18.0125C5.5837 15.9375 4.82953 13.6333 4.82953 11.1V5L12.8295 2L20.8295 5V11.1C20.8295 13.6333 20.0754 15.9375 18.567 18.0125C17.0587 20.0875 15.1462 21.4167 12.8295 22Z",
    fill: "#2F3846"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/Terms.2808387df833d21befefdc7284c853f9.svg";
export { ForwardRef as ReactComponent };